import { RoutePath } from '../app/app.constants';

export const sidebarWidthOpen = 300;
export const sidebarWidthClosed = 60;
export const mobileBreakpoint = 600;

export enum SidebarItem {
  NEW_CHAT = 'NEW_CHAT',
  YOUR_BOOKS = 'YOUR_BOOKS',
  YOUR_CHATS = 'YOUR_CHATS',
  INSTRUCTOR_INSIGHTS = 'INSTRUCTOR_INSIGHTS',
  HOW_IT_WORKS = 'HOW_IT_WORKS',
  VIEW_AS_STUDENT = 'VIEW_AS_STUDENT',
  BACK_TO_INSTRUCTOR_VIEW = 'BACK_TO_INSTRUCTOR_VIEW'
}

export const SidebarItemConfig: Record<SidebarItem, {
  iconName: string;
  iconPrefix: string;
  text: string;
  route: RoutePath;
}> = {
  [SidebarItem.NEW_CHAT]: {
    iconName: 'add-circle',
    iconPrefix: 'hmds',
    text: 'New chat',
    route: null
  },
  [SidebarItem.YOUR_BOOKS]: {
    iconName: 'books',
    iconPrefix: 'gizmo',
    text: 'Your books',
    route: RoutePath.YOUR_BOOKS
  },
  [SidebarItem.YOUR_CHATS]: {
    iconName: 'comment',
    iconPrefix: 'gizmo',
    text: 'Your chats',
    route: RoutePath.YOUR_CHATS
  },
  [SidebarItem.INSTRUCTOR_INSIGHTS]: {
    iconName: 'upwards-line-chart',
    iconPrefix: 'gizmo',
    text: 'Instructor insights',
    route: RoutePath.AI_CHAT_PERFORMANCE
  },
  [SidebarItem.HOW_IT_WORKS]: {
    iconName: 'information-outline-circle',
    iconPrefix: 'gizmo',
    text: 'How it works',
    route: RoutePath.HOW_IT_WORKS
  },
  [SidebarItem.VIEW_AS_STUDENT]: {
    iconName: 'eye-visible',
    iconPrefix: 'hmds',
    text: 'View as student',
    route: null
  },
  [SidebarItem.BACK_TO_INSTRUCTOR_VIEW]: {
    iconName: 'eye-visible',
    iconPrefix: 'hmds',
    text: 'Back to instructor view',
    route: null
  }
}
